import { styled } from '@linaria/react';
import { bodyFont, fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding-bottom: ${space['space-600']};
`;

export const InfoAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-300']};
  padding: ${space['space-300']} ${space['space-400']};
  background: ${semantic.bg.infoSubtle};
  color: ${semantic.text.info};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.info};
  border-radius: ${radius('notice', 'radius-sm')};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
`;

export const InfoIconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${semantic.icon.info};
  flex-shrink: 0;
`;

export const InfoAlertText = styled.span`
  flex: 1;
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const InfoAlertLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: ${semantic.text.info};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const DismissButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space['space-100']};
  color: ${semantic.icon.info};
  border-radius: ${radius('button', 'radius-xs')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;

  &:hover {
    background: ${semantic.bg.surfaceDefault};
  }
`;

export const FooterInner = styled.div`
  padding: ${space['space-400']} ${space['space-600']};
`;

export const InlinePanel = styled.section`
  background: ${semantic.bg.canvas};
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
`;

export const InlineHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-800']} ${space['space-600']} ${space['space-300']};
`;

export const InlineTitle = styled.h2`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const InlineCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space['space-100']};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  font-size: ${fonts.size.xl};
  line-height: 1;
  border-radius: ${radius('button', 'radius-xs')};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const InlineBody = styled.div`
  padding: 0 ${space['space-600']};
`;

export const InlineFooter = styled.div`
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.subtle};
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  padding: ${space['space-400']} 0 ${space['space-300']};
`;

export const SuccessTitle = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const SuccessBody = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
  margin: 0;
`;

export const ErrorMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.danger};
  background: ${semantic.bg.dangerSubtle};
  border-radius: ${radius('notice', 'radius-sm')};
  padding: ${space['space-300']} ${space['space-400']};
  margin: 0;
`;
